const CHANGE_USERINFO = 'CHANGE_USERINFO';

const initState = {
    accessToken: '',
    clientId: '',
    entitlements: undefined,
    uid: ''
};

const updateUserInfo = (state = initState, action) => {
    const { type = null, userinfo = {} } = action;

    if (type === CHANGE_USERINFO) {
        const newData = {
            ...state,
            ...userinfo
        };

        return newData;
    }

    return state;
};

export default updateUserInfo;
